import { createContext, useCallback, useContext, useEffect, useState } from "react";
import { http, errMsg } from "@/lib/api";

const Ctx = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [ready, setReady] = useState(false);

  const logout = useCallback(() => {
    localStorage.removeItem("srm_token");
    setUser(null);
  }, []);

  useEffect(() => {
    const onExpire = () => logout();
    window.addEventListener("srm-unauthorized", onExpire);
    if (!localStorage.getItem("srm_token")) {
      setReady(true);
    } else {
      http.get("/auth/me").then((r) => setUser(r.data)).catch(() => logout()).finally(() => setReady(true));
    }
    return () => window.removeEventListener("srm-unauthorized", onExpire);
  }, [logout]);

  const login = async (email, password) => {
    try {
      const r = await http.post("/auth/login", { email, password });
      localStorage.setItem("srm_token", r.data.token);
      setUser(r.data.user);
      return null;
    } catch (e) {
      const d = e?.response?.data?.detail;
      return Array.isArray(d) ? d.map((x) => x.msg).join(" ") : errMsg(e);
    }
  };

  const can = (...roles) => !!user && roles.includes(user.role);
  return <Ctx.Provider value={{ user, ready, login, logout, can }}>{children}</Ctx.Provider>;
}

export const useAuth = () => useContext(Ctx);
